import ExpressionLayout from "./ExpressionLayout";
import { soulInLove } from "./data";

const SoulInLovePage = () => <ExpressionLayout data={soulInLove} />;

export default SoulInLovePage;
